import $ from 'jquery';

export default {
    async getConfig(url) {
        return new Promise((resolve, rejected) =>
            $.ajax({
                url,
                type: 'get',
                xhrFields: {
                    withCredentials: false
                },
                dataType: 'json',
                crossDomain: true,
                contentType: 'application/json',
                success(response) {
                    resolve(response);
                },
                error: rawResponse => {
                    rejected(rawResponse);
                }
            })
        )
            .then(response => {
                return response;
            })
            .catch(response => {
                const { status } = response;
                console.error(`获取失败${status}`);
            });
    }
};
